import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
        <Path
            stroke={designSystem.colors.neutral600}
            strokeLinecap="round"
            strokeWidth={1.75}
            d="m11.53 4.46-7.07 7.072M4.46 4.469l7.071 7.07"
        />
    </Svg>
);
export default SvgComponent;
